export default __webpack_public_path__ + "static/media/rhea4.f0b3912f.png";